import React, {useState, useEffect} from "react";
import { useObjectStore } from "../zustand/objects";
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import EditIcon from '@mui/icons-material/Edit';

import { Box } from "@mui/material/";
import { ActionIcon, Tooltip} from '@mantine/core';


const SwitchToPreviewButton = ({mode, projectKey, iconColour}) => { 

  const {
    switchModes,
    currentObjectArtboard
  } = useObjectStore();

   
  const [show, setShow] = useState(false);
  const [showText, setShowText] = useState(false);
  const [divWidth, setDivWidth] = useState(50);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    show ? setDivWidth(110) : setDivWidth(70)
  })

  const handleClose = () => {
    setShow(false);
    setShowText(false);
  };

  return (


    <>
            <Tooltip label={(mode === "editor") ? "Preview in first person" : "Edit project"}>
            <ActionIcon
            c={!hover ? iconColour.normal : iconColour.hover}
            onPointerOver={() => setHover(true)}
            onPointerLeave={() => setHover(false)}
            onClick={() => {
              switchModes();
            }}
                component='a'
                href={mode === "editor" ? `/preview/${projectKey}?artboard=${currentObjectArtboard}` : `/editor/${projectKey}?artboard=${currentObjectArtboard}`}
                target="_blank"
                color={iconColour.normal}
                variant="transparent"
                aria-label="View storyboard">
                { (mode === "editor") ? <PlayArrowOutlinedIcon style={{ width: '80%', height: '80%' }} /> : <EditIcon  fontSize="medium" />}
            </ActionIcon></Tooltip>
    </>

  );
};

export default SwitchToPreviewButton;
